export default __webpack_public_path__ + "static/media/88ff9a5d00dd21b3757f724fbc400b1f.5022e202.png";